import { render, staticRenderFns } from "./FeedbackContacts.vue?vue&type=template&id=3f60948f"
import script from "./FeedbackContacts.vue?vue&type=script&lang=ts"
export * from "./FeedbackContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports